import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    poSummary: {
        '& > div > div > div > div:nth-child(1)': {
            background: '#666666',
            position: 'fixed',
            padding: '10px 0',
            width: '100%',
            marginTop: '0px'
        },
        '& > div > div > div > div:nth-child(2)': {
            marginTop: '60px'
        }
    }
});
